export default {
  LIST(state, data) {
    state.districts = data
  },
  UPDATE(state, value) {
    state.district = {
      ...value,
      region: value.region.id,
    }
  },
  FRESH(state) {
    state.district = {
      id: null,
      name: {
        uz: '',
        ru: '',
        en: '',
      },
      region: null,
    }
  },
}
